import React from "react"
import ContentLoader from "react-content-loader"

const NotificationLoader = (props) => (
  <ContentLoader 
    speed={2}
    width={1100}
    height={650}
    viewBox="0 0 1200 650"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="31" y="130" rx="0" ry="0" width="0" height="9" /> 
    <rect x="17" y="20" rx="0" ry="0" width="22" height="19" /> 
    <rect x="45" y="24" rx="0" ry="0" width="93" height="11" /> 
    <rect x="15" y="55" rx="0" ry="0" width="1190" height="4" /> 
    <rect x="16" y="76" rx="0" ry="0" width="58" height="13" /> 
    <circle cx="44" cy="139" r="26" /> 
    <rect x="83" y="122" rx="0" ry="0" width="70" height="9" /> 
    <rect x="162" y="122" rx="0" ry="0" width="59" height="10" /> 
    <rect x="83" y="139" rx="0" ry="0" width="170" height="8" /> 
    <rect x="83" y="155" rx="0" ry="0" width="70" height="5" /> 
    <rect x="15" y="183" rx="0" ry="0" width="1190" height="4" /> 
    <circle cx="44" cy="236" r="26" /> 
    <rect x="83" y="219" rx="0" ry="0" width="70" height="9" /> 
    <rect x="162" y="219" rx="0" ry="0" width="59" height="10" /> 
    <rect x="83" y="236" rx="0" ry="0" width="170" height="8" /> 
    <rect x="83" y="252" rx="0" ry="0" width="70" height="5" /> 
    <rect x="15" y="280" rx="0" ry="0" width="1190" height="4" /> 
    <circle cx="44" cy="336" r="26" /> 
    <rect x="83" y="319" rx="0" ry="0" width="70" height="9" /> 
    <rect x="162" y="319" rx="0" ry="0" width="59" height="10" /> 
    <rect x="83" y="336" rx="0" ry="0" width="170" height="8" /> 
    <rect x="83" y="352" rx="0" ry="0" width="70" height="5" /> 
    <rect x="15" y="380" rx="0" ry="0" width="1190" height="4" /> 
    <circle cx="44" cy="437" r="26" /> 
    <rect x="83" y="420" rx="0" ry="0" width="70" height="9" /> 
    <rect x="162" y="420" rx="0" ry="0" width="59" height="10" /> 
    <rect x="83" y="437" rx="0" ry="0" width="170" height="8" /> 
    <rect x="83" y="453" rx="0" ry="0" width="70" height="5" /> 
    <rect x="15" y="481" rx="0" ry="0" width="1190" height="4" /> 
    <circle cx="44" cy="537" r="26" /> 
    <rect x="83" y="520" rx="0" ry="0" width="70" height="9" /> 
    <rect x="162" y="520" rx="0" ry="0" width="59" height="10" /> 
    <rect x="83" y="537" rx="0" ry="0" width="170" height="8" /> 
    <rect x="82" y="553" rx="0" ry="0" width="70" height="5" /> 
    <rect x="15" y="581" rx="0" ry="0" width="1190" height="4" />
  </ContentLoader>
)

export default NotificationLoader;